module.exports = __webpack_public_path__ + "img/icon_delete.feaa2ce2.svg";